export default "__VITE_ASSET__DmCLD8Hg__"